<template>
  <div class="
    flex justify-between items-center 
    border-gray-300 border-solid border-b pb-4 mt-4
    ">
    <a href="#" class="icon text-gray-500 hover:text-jblue mr-2 sm:mr-4 mt-1" @click.prevent="$emit('remove')">
      <svg height='15px' width='15px' class="fill-current" xmlns:x="http://ns.adobe.com/Extensibility/1.0/" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" xmlns:graph="http://ns.adobe.com/Graphs/1.0/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve"><g><g i:extraneous="self"><g><g><g><path d="M252,477c-0.7,0-1.5,0-2.2,0c-53.5-0.7-109.9-26.9-154.8-71.9C50,360,24.2,303.4,24.2,250       S50,140,95,94.9c44.9-45,101.3-71.2,154.8-71.9c53-0.7,108.8,24.1,153.3,67.9c46.2,45.6,72.8,103.6,72.8,159       s-26.5,113.4-72.8,159C359.2,452.3,304.3,477,252,477z M252,53c-0.6,0-1.2,0-1.8,0c-45.7,0.6-94.6,23.6-134,63.1       C76.8,155.6,54.2,204.4,54.2,250c0,45.6,22.6,94.4,62.1,133.9c39.4,39.5,88.2,62.5,134,63.1c45,0.6,93-21,131.8-59.3       c40-39.4,63.8-90.9,63.8-137.7c0-46.8-23.9-98.2-63.8-137.7C343.7,74.6,296.5,53,252,53z"></path></g><g><g><path d="M328.8,344.2c-3.8,0-7.7-1.5-10.6-4.4c-26.3-26.3-53-53.2-78.7-79.1c-25.8-26-52.5-52.9-78.9-79.2        c-5.9-5.9-5.9-15.4,0-21.2c5.9-5.9,15.4-5.9,21.2,0c26.4,26.4,53.1,53.3,78.9,79.3c25.8,25.9,52.4,52.8,78.7,79        c5.9,5.9,5.9,15.4,0,21.2C336.5,342.7,332.6,344.2,328.8,344.2z"></path></g><g><path d="M171.2,344.2c-3.8,0-7.7-1.5-10.6-4.4c-5.9-5.9-5.9-15.4,0-21.2c26.3-26.3,53-53.2,78.8-79.2        c25.8-26,52.5-52.8,78.8-79.2c5.9-5.9,15.4-5.9,21.2,0c5.9,5.9,5.9,15.4,0,21.2c-26.3,26.3-52.9,53.1-78.7,79.1        c-25.8,26-52.5,52.9-78.9,79.2C178.9,342.7,175,344.2,171.2,344.2z"></path></g></g></g></g></g></g></svg>
    </a>
    <div class="text-left flex justify-start items-center flex-1 cursor-pointer" @click.prevent="$emit('edit')">
      <div>
        {{product.name}}
        <small class="block">{{flavours.join(", ")}}</small>
        <small class="block" v-if="item.topper">with Topper</small>
        <small class="block" v-if="item.bacon">without Maple Bacon</small>
        <template v-if="item.cake">
          <template v-if="item.colour"><small >Colour: <strong>{{item.colour}}</strong></small><br/></template>
          <template v-if="showMessage">
          <small>Message: <strong>{{item.message ? item.message : "No message"}}</strong></small>
          </template>
        </template>
      </div>
      
      <div class=" 
        border-jblue border border-solid px-2 py-1 text-xs font-proxima uppercase text-jblue 
        hover:text-white hover:bg-jblue ml-3 sm:ml-4">
        Edit
      </div>
    </div>
    <p style="width: 60px" class="text-right ml-2 sm:ml-4">{{product.amount | currency }}</p>
  </div>
</template>

<script>
import { find, filter, map } from 'lodash'
export default {
  props: ['item'],
  computed: {
    showMessage() {
      return this.group && this.group.message
    },
    group() {
      return find(this.$root.$data.groups, {id: this.product.group})
    },
    product() {
      return find(this.$root.$data.products, {sku: this.item.sku} )
    },
    flavours() {
      return map(filter(this.$root.$data.flavours, o => this.item.flavours.includes(o.id) ),'name')

    }
  }
}
</script>

<style>
.icon {
  width: 15px;
}
</style>